import compact from "lodash/compact";
export default (node) => { var _a; return compact(((_a = node.tag) === null || _a === void 0 ? void 0 : _a.Nodes) ? node.tag.Nodes : [node.tag]); };
